// Whether a person Scout found may be sent to. Pure, so `node --test` covers it. The server's
// push and sequence create enforce the same rule (app.py `_withheld_reason`).
import type { FoundByScout } from '../api/types.ts';

// The source of a person enriched from their LinkedIn profile in the extension (extension/person.py
// ENRICHED_SOURCE): listed beside Scout's finds, labelled Enriched.
export const ENRICHED_SOURCE = 'linkedin_enrich';

/** Whether a found person came from the extension's Enrich rather than a Scout search. */
export function isEnrichedFind(found: FoundByScout | null | undefined): boolean {
  return found?.source === ENRICHED_SOURCE;
}

/** True for a Scout find that is held back from every send. A missing status counts as held. */
export function foundNotCleared(contact: { found_by_scout?: FoundByScout | null }): boolean {
  const found = contact.found_by_scout;
  if (!found) return false;
  return found.send_status !== 'cleared' && found.send_status !== 'dry_run_only';
}
